import { createBasePlugin, DraftOffsetKey, } from 'wix-rich-content-editor-common';
import { DA_SCROLLER_TYPE } from './types';
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('editor.scroller');
var CONTENT_PADDING = 200; // The amount of extra space we want after last line
var NEAR_PADDING = 100;
function scrollerPluginCreator() {
    return function (config) {
        var decorator = config.decorator, helpers = config.helpers, theme = config.theme, isMobile = config.isMobile, t = config.t, getEditorState = config.getEditorState;
        return createBasePlugin({
            decorator: decorator,
            theme: theme,
            type: DA_SCROLLER_TYPE,
            toolbar: {},
            helpers: helpers,
            isMobile: isMobile,
            t: t,
        }, {
            keyBindingFn: function (event) {
                // Limit to only non typing events
                if (event.key !== 'Enter' &&
                    event.key !== 'ArrowDown' &&
                    event.key !== 'ArrowUp' &&
                    event.key !== 'PageUp' &&
                    event.key !== 'PageDown') {
                    return;
                }
                var scrollableRef = helpers.scrollableRef;
                var editorState = getEditorState();
                if (!scrollableRef || !scrollableRef.current) {
                    return;
                }
                var selection = editorState.getSelection();
                var currentContent = editorState.getCurrentContent();
                var currentBlock = currentContent.getBlockForKey(selection.getStartKey());
                var offsetKey = DraftOffsetKey.encode(currentBlock.getKey(), 0, 0);
                var query = document.querySelectorAll('[data-offset-key][data-block=true]');
                if (query) {
                    // Measure all blocks
                    var contentHeight_1 = 0;
                    Array.from(query).map(function (node) {
                        contentHeight_1 += node.getBoundingClientRect().height;
                        return node;
                    });
                    // Next scroll to the focused block
                    // eslint-disable-next-line
                    Array.from(query).map(function (node) {
                        if (!node || !node.offsetTop || !scrollableRef.current) {
                            // eslint-disable-next-line
                            return;
                        }
                        var key = node.getAttribute('data-offset-key');
                        if (key === offsetKey) {
                            requestAnimationFrame(function () {
                                if (!node || !scrollableRef.current) {
                                    return;
                                }
                                // Get the blocks position relative to the page, we can then
                                // check if its near the bottom of the screen
                                var bodyRect = document.body.getBoundingClientRect();
                                var blockRect = node.getBoundingClientRect();
                                var blockOffset = blockRect.top - bodyRect.top;
                                var viewportHeight = window.visualViewport
                                    ? window.visualViewport.height
                                    : document.documentElement.clientHeight;
                                // TODO calculate viewport offsets for mobile
                                // Scroll if we are near the edge of the window
                                if (blockOffset + blockRect.height + NEAR_PADDING >=
                                    viewportHeight) {
                                    var editor = node.closest('.da-editor');
                                    if (editor) {
                                        editor.style.height = contentHeight_1 + CONTENT_PADDING + "px";
                                    }
                                    node.scrollIntoView();
                                    logger.log('Scrolling to block it was near end or out of screen');
                                }
                                // Scroll if we are outside the view
                                var scrollableRect = scrollableRef.current.getBoundingClientRect();
                                var blockParentOffset = blockRect.top - scrollableRect.top;
                                if (blockParentOffset < 0) {
                                    node.scrollIntoView();
                                    logger.log('Scrolling to block it was outside the top scrollable');
                                }
                            });
                        }
                    });
                }
            },
        });
    };
}
export { scrollerPluginCreator, DA_SCROLLER_TYPE };
//# sourceMappingURL=createScrollerPlugin.js.map